import React, { useEffect, useState } from "react";

export function TabState({ loading, error, data, children }) {
  if (loading && !data) return <div className="pc-empty">Загрузка…</div>;
  if (error && !data) return <div className="pc-empty">{error}</div>;
  if (!data) return null;
  return children;
}

// Ссылка на карточку AmoCRM: просмотр / редактирование / добавление
export function AmoLinkEditor({ url, onSave, openLabel = "Открыть сделку в AmoCRM ↗" }) {
  const [editing, setEditing] = useState(!url);
  const [value, setValue] = useState(url || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(url || "");
    setEditing(!url);
  }, [url]);

  const save = async () => {
    setSaving(true);
    try {
      await onSave(value.trim() || null);
    } finally {
      setSaving(false);
    }
  };

  if (!editing) {
    return (
      <div className="pc-row">
        <span className="tag ok">В AmoCRM</span>
        <a className="pc-btn sm" href={url} target="_blank" rel="noreferrer">
          {openLabel}
        </a>
        <button type="button" className="pc-btn sm" onClick={() => setEditing(true)}>
          ✏️ Изменить
        </button>
      </div>
    );
  }

  return (
    <div className="pc-row">
      {!url && <span className="tag warn">Нет в AmoCRM</span>}
      <input
        type="url"
        className="pc-input browser-default"
        style={{ flex: "1 1 220px" }}
        placeholder="Вставьте ссылку на карточку AmoCRM"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") save();
        }}
      />
      <button type="button" className="pc-btn sm primary" onClick={save} disabled={saving}>
        Сохранить
      </button>
      {url && (
        <button type="button" className="pc-btn sm" onClick={() => setEditing(false)}>
          Отмена
        </button>
      )}
    </div>
  );
}

// Текстовое поле с сохранением по Enter / Blur
export function InlineText({ value, placeholder, onSave, maxLength }) {
  const [text, setText] = useState(value || "");

  useEffect(() => setText(value || ""), [value]);

  const commit = () => {
    if ((value || "") !== text.trim()) onSave(text.trim() || null);
  };

  return (
    <input
      type="text"
      className="pc-input browser-default"
      style={{ width: "100%" }}
      placeholder={placeholder}
      maxLength={maxLength}
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.currentTarget.blur();
      }}
    />
  );
}
